export const ECT_CREDENTIALS = {
  message_delivery_salesforce: {
    credentials: [
      { name: 'base_url', required: true, type: 'TEXT', label: 'Base URL' },
      {
        name: 'org_id',
        required: true,
        type: 'TEXT',
        label: 'Organisation Id',
      },
      {
        name: 'deployment_id',
        required: true,
        type: 'TEXT',
        label: 'Deployment Id',
      },
      { name: 'button_id', required: true, type: 'TEXT', label: 'Button Id' },
      {
        name: 'chat_request_fail',
        required: true,
        type: 'TEXT',
        label: 'Chat Request Fail',
      },
      {
        name: 'chat_request_pending',
        required: true,
        type: 'TEXT',
        label: 'Chat Request Pending',
      },
      { name: 'chat_ended', required: true, type: 'TEXT', label: 'Chat Ended' },
      {
        name: 'language_code',
        required: false,
        type: 'TEXT',
        label: 'Language Code',
      },
      {
        name: 'live_case_creation',
        required: true,
        type: 'BOOLEAN',
        label: 'Live Agent Case Creation',
      },
      {
        name: 'offline_case_creation',
        required: true,
        type: 'BOOLEAN',
        label: 'Agents Offline Case Creation',
      },
      {
        name: 'sf_user_name',
        required: false,
        type: 'TEXT',
        label: 'Salesforce User Name',
      },
      {
        name: 'sf_client_id',
        required: false,
        type: 'TEXT',
        label: 'Salesforce Client Id',
      },
      {
        name: 'sf_private_key',
        required: false,
        type: 'TEXT',
        label: 'Salesforce Private Key',
      },
    ],
  },
  message_delivery_freshdesk: {
    credentials: [
      { name: 'base_url', required: true, type: 'TEXT', label: 'Base URL' },
      { name: 'app_id', required: true, type: 'TEXT', label: 'App Id' },
      { name: 'channel_id', required: true, type: 'TEXT', label: 'Channel Id' },
      {
        name: 'bot_agent_id',
        required: true,
        type: 'TEXT',
        label: 'Bot Agent Id',
      },
      { name: 'api_key', required: true, type: 'TEXT', label: 'API Key' },
      {
        name: 'custom_keys',
        required: true,
        type: 'TEXT',
        label: 'Custom Keys',
      },
    ],
  },
  message_delivery_nice: {
    credentials: [
      {
        name: 'api_version',
        required: true,
        type: 'TEXT',
        label: 'API Version',
      },
      { name: 'app_name', required: true, type: 'TEXT', label: 'App Name' },
      {
        name: 'chat_request_success',
        required: true,
        type: 'TEXT',
        label: 'Chat Request Success',
      },
      {
        name: 'chat_request_pending',
        required: true,
        type: 'TEXT',
        label: 'Chat Request Pending',
      },
      { name: 'chat_ended', required: true, type: 'TEXT', label: 'Chat Ended' },
      {
        name: 'vendor_name',
        required: true,
        type: 'TEXT',
        label: 'Vendor Name',
      },
      {
        name: 'application_id',
        required: true,
        type: 'TEXT',
        label: 'Application ID',
      },
      {
        name: 'language_code',
        required: false,
        type: 'TEXT',
        label: 'Language Code',
      },
    ],
  },
  zendesklivechat: {
    credentials: [
      {
        name: 'client_name',
        required: true,
        type: 'TEXT',
        label: 'Client Name',
      },
      {
        name: 'zd_client_id',
        required: true,
        type: 'TEXT',
        label: 'ZD Client ID',
      },
      { name: 'subdomain', required: true, type: 'TEXT', label: 'Subdomain' },
      {
        name: 'client_secret',
        required: true,
        type: 'TEXT',
        label: 'Client Secret',
      },
      {
        name: 'authorize_url',
        required: false,
        type: 'TEXT',
        label: 'Authorize URL',
      },
      {
        name: 'break_message',
        required: false,
        type: 'TEXT',
        label: 'Bot Break Message',
      },
      {
        name: 'agent_offline_message',
        required: true,
        type: 'TEXT',
        label: 'Agent Offline Message',
      },
    ],
  },
  message_delivery_genesys: {
    credentials: [
      {
        name: 'genesys_baseurl',
        required: false,
        type: 'TEXT',
        label: 'Genesys Base URL',
      },
      {
        name: 'org_id',
        required: true,
        type: 'TEXT',
        label: 'Organization Id',
      },
      {
        name: 'deployment_id',
        required: true,
        type: 'TEXT',
        label: 'Deployment Id',
      },
      { name: 'queue_name', required: true, type: 'TEXT', label: 'Queue Name' },
      { name: 'secret_key', required: true, type: 'TEXT', label: 'Secret Key' },
    ],
  },
  glia: {
    credentials: [
      {
        name: 'base_url',
        required: true,
        type: 'TEXT',
        label: 'GLIA BASE URL',
      },
      { name: 'queue_id', required: true, type: 'TEXT', label: 'QUEUE ID' },
      {
        name: 'operator_api_key',
        required: true,
        type: 'TEXT',
        label: 'OPERATOR API KEY',
      },
    ],
  },
  ameyo: {
    credentials: [
      { name: 'base_url', required: true, type: 'TEXT', label: 'Base URL' },
      {
        name: 'port_number',
        required: true,
        type: 'TEXT',
        label: 'Port Number',
      },
      {
        name: 'application_id',
        required: true,
        type: 'TEXT',
        label: 'Application ID',
      },
    ],
  },
  message_delivery_zoho: {
    credentials: [
      {
        name: 'transfer_organization_id',
        required: false,
        type: 'TEXT',
        label: 'Transfer Organization Number',
      },
      {
        name: 'zoho_client_id',
        required: false,
        type: 'TEXT',
        label: 'Zoho Client ID',
      },
      {
        name: 'zoho_client_secret',
        required: false,
        type: 'TEXT',
        label: 'Zoho Client Secret',
      },
      {
        name: 'zoho_agent_busy_text',
        required: true,
        type: 'TEXT',
        label: 'Zoho Agent Busy Text',
      },
      {
        name: 'zoho_agent_offline_text',
        required: true,
        type: 'TEXT',
        label: 'Zoho Agent Offline Text',
      },
      {
        name: 'zoho_agent_busy_other_text',
        required: true,
        type: 'TEXT',
        label: 'Zoho Agent Busy Other Text',
      },
      {
        name: 'zoho_agent_transfer_text',
        required: true,
        type: 'TEXT',
        label: 'Zoho Agent Transfer Text',
      },
    ],
  },
  message_delivery_NiceCXO: {
    credentials: [
    {
      name: 'api_version',
      required: true,
      type: 'TEXT',
      label: 'API Version',
    },
    {
      name: 'access_key',
      required: true,
      type: 'TEXT',
      label: 'Access key',
    },
    {
      name: 'secret_key',
      required: true,
      type: 'TEXT',
      label: 'Secret key',
    },
    {
      name: 'domain',
      required: true,
      type: 'TEXT',
      label: 'Domain (Example - https://jp1.niceincontact.com for Japan)',
    },
    {
      name: 'patron_url',
      required: true,
      type: 'TEXT',
      label: 'Patron Base URL (Example - https://api-j32.niceincontact.com for Japan)',
    },
    {
      name: 'poc_id',
      required: true,
      type: 'TEXT',
      label: 'POC ID (Point of contact ID)',
    },
    {
      name: 'chat_request_success',
      required: false,
      type: 'TEXT',
      label: 'Chat Request Success',
    },
    {
      name: 'chat_request_pending',
      required: false,
      type: 'TEXT',
      label: 'Chat Request Pending',
    },
    {
      name: 'chat_ended',
      required: false,
      type: 'TEXT',
      label: 'Chat Ended',
    }
  ]
  }
};

export const ERROR_MESSAGE_SAVE =
  'Something went wrong while saving. Please try again in some time.';

export const ERROR_MESSAGE_DELETE =
  'Something went wrong while deleting. Please try again in some time.';

export const ERROR_MESSAGE_FETCH =
  'Something went wrong. Please try again in some time.';

export const ZOHO_FQDN = 'message_delivery_zoho';
